import { Palette } from 'lucide-react';
import { getTemplateById } from '@/config/templates';

interface UserMessageProps {
  content: string;
  style?: string; // Template ID from prompt.style
  templateUsed?: {
    id: string;
    title: string;
    icon?: string;
  };
}

export default function UserMessage({ content, style, templateUsed }: UserMessageProps) {
  // Try to get template from style ID first, fall back to templateUsed prop
  const template = style ? getTemplateById(style) : null;
  const templateInfo = template ? { id: template.id, title: template.title, icon: template.icon } : templateUsed;
  
  return (
    <div className="flex justify-end mb-6">
      <div className="max-w-[70%]">
        {templateInfo && (
          <div className="flex justify-end mb-1">
            <div className="flex items-center gap-1.5 bg-gradient-to-bl from-[#00FFBF]/10 to-[#2E95FF]/10 dark:from-[#00FFBF]/5 dark:to-[#2E95FF]/5 px-2.5 py-1 rounded-lg">
              <Palette className="w-3 h-3 text-[#2E95FF] dark:text-[#00FFBF]" />
              <span className="text-xs font-medium text-gray-600 dark:text-gray-400">
                {templateInfo.title} Template
              </span>
            </div>
          </div>
        )}
        <div className="px-4 py-2 rounded-2xl bg-gray-100 dark:bg-gray-800 transition-colors">
          <div className="text-gray-800 dark:text-gray-200">{content}</div>
        </div>
      </div>
    </div>
  );
}